import { useCallback, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { ArrowUpRight, Menu, X } from 'lucide-react';
import { Link, NavLink } from 'react-router-dom';
import { navigation } from '@/data/company';
import { Button } from './Button';
import { MobileMenu } from './MobileMenu';
import { ThemeToggle } from './ThemeToggle';

function Logo() {
  return (
    <Link
      to="/"
      className="group flex shrink-0 items-center gap-2.5 rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/35"
      aria-label="Helmflex — početna stranica"
    >
      <span className="relative grid size-9 place-items-center overflow-hidden rounded-[var(--radius-sm)] bg-primary text-sm font-bold text-on-primary">
        H
      </span>
      <span className="text-lg font-bold tracking-[-0.035em] text-text-primary">
        helm<span className="text-primary">flex</span>
      </span>
    </Link>
  );
}

export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = useCallback(() => setMenuOpen(false), []);

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-border bg-background/96 backdrop-blur-md">
      <div className="site-container flex h-[4.6rem] items-center justify-between gap-6">
        <Logo />

        <nav
          className="hidden items-center gap-1 lg:flex"
          aria-label="Glavna navigacija"
        >
          {navigation.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `nav-link-animated px-4 py-2 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/35 ${
                  isActive
                    ? 'is-active text-primary'
                    : 'text-text-secondary hover:text-text-primary'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2.5">
          <ThemeToggle />
          <div className="hidden sm:block">
            <Button to="/kontakt" size="sm">
              Kontaktirajte nas
              <ArrowUpRight aria-hidden="true" className="size-4" />
            </Button>
          </div>
          <button
            className="grid size-11 cursor-pointer place-items-center rounded-[var(--radius-sm)] border border-border bg-surface text-text-primary transition-colors hover:border-primary hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/35 lg:hidden"
            type="button"
            aria-expanded={menuOpen}
            aria-controls="mobile-menu"
            aria-label={menuOpen ? 'Zatvori meni' : 'Otvori meni'}
            onClick={() => setMenuOpen(open => !open)}
          >
            {menuOpen ? (
              <X aria-hidden="true" className="size-5" />
            ) : (
              <Menu aria-hidden="true" className="size-5" />
            )}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {menuOpen && (
          <div id="mobile-menu">
            <MobileMenu isOpen={menuOpen} onClose={closeMenu} />
          </div>
        )}
      </AnimatePresence>
    </header>
  );
}
